__turbopack_context__.v({
  "cell_btn": "Cost-module-scss-module__Jp5qmq__cell_btn",
  "container": "Cost-module-scss-module__Jp5qmq__container",
  "table": "Cost-module-scss-module__Jp5qmq__table",
});
